import React, { useMemo } from "react";
import { Link, Typography } from "@mui/material";
import { buildPathLinkSegments } from "../../utils/chatbotFlowPathNavigation";

const SEPARATOR = " › ";

export default function ChatbotFlowPathLinks({
  path,
  slots = [],
  targetSlotId = null,
  onNavigate,
  variant = "body2",
  emptyLabel = "—",
}) {
  const segments = useMemo(
    () => buildPathLinkSegments(path, slots, targetSlotId),
    [path, slots, targetSlotId]
  );

  if (!path || !segments.length) {
    return (
      <Typography variant={variant} component="span" color="text.secondary">
        {emptyLabel}
      </Typography>
    );
  }

  return (
    <Typography variant={variant} component="span" sx={{ wordBreak: "break-word" }}>
      {segments.map((segment, index) => (
        <React.Fragment key={`${index}-${segment.label}`}>
          {index > 0 ? SEPARATOR : null}
          {segment.slotId && onNavigate ? (
            <Link
              component="button"
              type="button"
              variant={variant}
              underline="hover"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onNavigate(segment.slotId);
              }}
              sx={{
                verticalAlign: "baseline",
                fontWeight: index === segments.length - 1 ? 600 : 400,
                textAlign: "left",
              }}
            >
              {segment.label}
            </Link>
          ) : (
            segment.label
          )}
        </React.Fragment>
      ))}
    </Typography>
  );
}
